import { User } from '../../../../shared/models/user';
import { Metropolis } from '../../admin-global/models/metropolis';
import { Candidate } from '../../../../pv-modules/pv-recruitment/models/Candidate';
import {UserIdentityCheck} from '../../../../pv-modules/pv-recruitment/models/UserIdentityCheck';

export interface Valet {
  id: string;
  activeLogs: UserActiveLog[];
  valetInvoicingBlockLogs: UserInvoicingBlockLogs[];
  title: string;
  firstName: string;
  lastName: string;
  birthDate: string;
  invoicingBlockReason: string;
  invoicingBlockComment: string;
  email: string;
  phone: string;
  profilePictureFile: ProfilePictureFile | null;
  // ADDRESS
  metropolis: Metropolis;
  addressLabel: string | null;
  candidate: Candidate;
  address: string;
  city: string;
  postalCode: string;
  country: string;
// BILLING
  siret: string;
  billingAddress: string;
  billingCity: string;
  billingPostalCode: string;
  billingCountry: string;
  enableLastbill: boolean;
  // REMUNERATION
  remunerationIBAN: string;
  feesIBAN: string;
  // Additional Information
  ready: boolean | null;
  active: boolean | null;
  drivesVU: boolean | null;
  sncfStatus: boolean | null;
  warning: boolean | null;
  status: string;
  sign: boolean;
  contractTransactionId: string;
  averageClientRate: number;
  referralCode: string;
  creationDate: string;
  isFraudulent: boolean;
  missionCount: number;
  hasInsurer: boolean;
  drivingLicenseNumber: string | null;
  blockRemuneration: boolean;
  blockExpenses: boolean;
  preferredDistance: string;
  wGarage: string;
  hasWGarage: boolean;
  copyAddresses: boolean;
  identityCheck: UserIdentityCheck;
}

export interface ProfilePictureFile {
  url: string;
}

export interface FraudCategory {
  expenseCategory: Category,
  isFraudulent: boolean,
  fraudPercent: number,
  fraudNumber: number
}

export const DrivesVUOptions = [
  { value: true, name: 'Oui' },
  { value: false, name: 'Non' },
  { value: null, name: 'Non spécifié' },
];

export enum Category {
  Autre = 'autre',
  Carburant = 'carburant',
  FraisKilometriques = 'fraisKilometriques',
  FraisKilometriquesVelo = 'fraisKilometriquesVelo',
  RechargeElectrique = 'rechargeElectrique',
  Parking = 'parking',
  Hebergement = 'hebergement',
  Repas = 'repas',
  Peages = 'peages',
  Poste = 'poste',
  Taxi = 'taxi',
  Transport = 'transport',
  Lavage = 'lavage'
}

export interface UserActiveLog {
  id: string;
  admin?: User | null;
  date: string;
  active: boolean;
  ready: boolean | null;
  disableReason: string | null;
  disableComment: string | null;
  user: User;
}

export interface UserInvoicingBlockLogs {
  id: string;
  admin?: User | null;
  date: string;
  blockRemuneration: boolean;
  blockExpenses: boolean;
  invoicingBlockReason: string | null;
  invoicingBlockComment: string | null;
  user: User;
}
